module.exports = __webpack_public_path__ + "34b1b742ea5ee2d862f3034a31022e50.svg";